import { organizationProjectListVariants } from '@/features/organization-project-picker/config/organizationTree';
import type {
  OrganizationTreeDensity,
  OrganizationTreeProjectQuery,
  OrganizationTreeRow,
} from '@/features/organization-project-picker/types/organizationTree';
import { ListNextPageFooter } from '@/shared/components/ListStatus';
import type { CSSProperties, Ref } from 'react';

export function OrganizationTreeProjectFooterRow({
  density,
  edge,
  query,
  measureRef,
  virtualIndex,
  style,
}: {
  density: OrganizationTreeDensity;
  edge: Extract<OrganizationTreeRow, { kind: 'project-footer' }>['edge'];
  query: OrganizationTreeProjectQuery;
  measureRef?: Ref<HTMLLIElement>;
  virtualIndex: number;
  style: CSSProperties;
}) {
  return (
    <li ref={measureRef} data-index={virtualIndex} style={style}>
      <div className={organizationProjectListVariants({ density, edge })}>
        <ListNextPageFooter query={query} />
      </div>
    </li>
  );
}
